<div class="our-rooms-section mb-20">
    <h1 class="text-5xl text-center mb-20">Ou<span class="underline underline-offset-8">r Roo</span>ms</h1>

    <div class="grid sm:grid-flow-row md:grid-flow-col md:grid-cols-3 mx-4 gap-4">
        <app-room-card image="card1" title="Spacious" content="Spaciousness that allows you to fully unwind during your stay." />
        <app-room-card image="card2" title="Clean and Hygienic" content="Sanitized and cleaned between each occupancy." />
        <app-room-card
            image="card3"
            title="Minimalistic Decor"
            content="A sleek and modern aesthetic that promotes relaxation and a sense of calm."
        />
    </div>
</div>
